module.exports = __webpack_public_path__ + "media/images/arrow-right-black-b52d4f7deed201eb6d19cd7bdff2e48a.svg";